import {Modal} from "bootstrap";
import prepareAjaxForm from "./lib/prepare-ajax-form"

const openModalBtnList = document.querySelectorAll('.form-modal-btn')
const modalElement = document.getElementById('form-modal')
if (modalElement && openModalBtnList.length > 0) {
    const modal = new Modal(modalElement)
    const form = document.getElementById('form-modal-form')
    const submitBtn = document.getElementById('form-modal-submit-btn')
    const modalBody = modalElement.querySelector('.form-element-container')
    const modalFooter = modalElement.querySelector('.modal-footer')
    openModalBtnList.forEach(btn => {
        const formContainer = document.getElementById(btn.dataset.formContainerId).cloneNode(true)
        btn.addEventListener('click', () => {
            const modalTitleElement = modalElement.querySelector('.modal-title')
            form.action = btn.dataset.formAction
            modalTitleElement.innerText = btn.dataset.modalTitle
            submitBtn.innerText = btn.dataset.submitBtnLabel
            formContainer.classList.remove('hidden')
            modalBody.replaceChildren(formContainer)
            modalFooter.classList.remove('hidden')
            submitBtn.classList.remove('hidden')
            submitBtn.disabled = false
            modal.show()
        })
    })
    prepareAjaxForm(form)
}
